<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-08-12 15:42:57
-->
<template>
	<div>
		<div class="flex flex-align-center">
			<div :class="['state_icon', row.other_status == '1' ? 'success' : 'danger']"></div>
			<div class="ml-10 ml-6">{{ row.other_status_desc || row.promote_status_name }}</div>
		</div>
		<div v-if="column.key !== 'todoPromote'" class="ml-18">推荐次数：{{ row.promote_num }}</div>
	</div>
</template>
<script>
import mixin from './mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
.state_icon {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.success {
	background-color: @color-success;
}
.danger {
	background-color: @color-danger;
}
</style>
